import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";

export const AgentSection = ({
  children,
  description,
  title,
  trailing,
}: {
  children: ReactNode;
  description?: string;
  title: string;
  trailing?: ReactNode;
}) => (
  <StyledSection aria-label={title}>
    <StyledHeader>
      <StyledHeadingGroup>
        <StyledTitle
          as="h2"
          color={MDSTextColor.Primary}
          variant={MDSTextVariant.HeaderS}
          weight={MDSTextWeight.SemiBold}
        >
          {title}
        </StyledTitle>
        {description ? (
          <MDSText color={MDSTextColor.Tertiary} variant={MDSTextVariant.TextS}>
            {description}
          </MDSText>
        ) : null}
      </StyledHeadingGroup>
      {trailing ? <StyledTrailing>{trailing}</StyledTrailing> : null}
    </StyledHeader>
    {children}
  </StyledSection>
);

export const AgentSectionCard = styled.div`
  background: ${({ theme }) => theme.colors.background.card.default};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  min-width: 0;
  overflow: hidden;
`;

export const AgentSectionEmptyState = styled(AgentSectionCard)`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextS]};
  padding: ${({ theme }) => theme.spacing[5]};
`;

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
  min-width: 0;
`;

const StyledHeader = styled.header`
  align-items: flex-end;
  display: flex;
  gap: ${({ theme }) => theme.spacing[4]};
  justify-content: space-between;
  min-width: 0;
`;

const StyledHeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
  min-width: 0;
`;

const StyledTitle = styled(MDSText)`
  margin: 0;
`;

const StyledTrailing = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: ${({ theme }) => theme.spacing[2]};
`;
